import { render, staticRenderFns } from "./TableLoadingBar.vue?vue&type=template&id=15a12b0b&scoped=true"
import script from "./TableLoadingBar.vue?vue&type=script&lang=js"
export * from "./TableLoadingBar.vue?vue&type=script&lang=js"
import style0 from "./TableLoadingBar.vue?vue&type=style&index=0&id=15a12b0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a12b0b",
  null
  
)

export default component.exports